/*
 Simrou v1.5.4 - Released under the MIT License.
 Copyright (c) 2012 büro für ideen, www.buero-fuer-ideen.de
*/ (function() {
    var j, l = function l(a, b) {
        return function() {
            return a.apply(b, arguments);
        };
    }, k = {}.hasOwnProperty, m = [].slice, d = function d(a) {
        this.handleFormSubmit = l(this.handleFormSubmit, this);
        this.resolveHash = l(this.resolveHash, this);
        this.routes = {};
        this.observeForms = this.observeHash = this.listening = !1;
        null != a && this.addRoutes(a);
        null != this.initialize && this.initialize();
    };
    d.prototype.RegExpCache = {
        extractHash: /^[^#]*(#.*)$/,
        trimHash: /^#*(.*?)\/*$/
    };
    var g = d.prototype, i;
    i = window.document.documentMode;
    g.eventSupported = "onhashchange" in window && (null == i || 7 < i);
    d.prototype.addRoute = function(a, b) {
        var c;
        null == b && (b = !0);
        c = a instanceof j ? a : new j(a, b);
        return this.routes[c.toString()] = c;
    };
    d.prototype.addRoutes = function(a, b) {
        var c, e, f, h;
        null == b && (b = !0);
        if (jQuery.isFunction(a)) e = a.call(this, b);
        else if (jQuery.isArray(a)) {
            e = [];
            c = 0;
            for(f = a.length; c < f; c++)h = a[c], e.push(this.addRoutes(h, b));
        } else if (jQuery.isPlainObject(a)) for(f in e = {}, a)k.call(a, f) && (c = a[f], h = this.addRoute(f, b), h.attachActions(c), e[f] = h);
        else e = this.addRoute(a, b);
        return e;
    };
    d.prototype.removeRoute = function(a) {
        a instanceof j || (a = new j(a));
        a = a.toString();
        if (a in this.routes) return delete this.routes[a];
    };
    d.prototype.navigate = function(a) {
        var b;
        b = this.getHash();
        location.hash = a;
        if (!this.observeHash || location.hash === b) return this.resolve(a, "get");
    };
    d.prototype.resolve = function(a, b) {
        var c, e, f, h, d;
        e = String(a).replace(this.RegExpCache.trimHash, "$1");
        if ("" === e) {
            if (-1 === String(a).indexOf("/")) return !1;
            e = "/";
        }
        d = this.routes;
        for(f in d)if (k.call(d, f) && (c = d[f], c instanceof j && (h = c.match(e)))) return e = [
            h,
            b
        ], c = jQuery(c), c.trigger("simrou:any", e), null != b && "any" !== b && c.trigger("simrou:" + b.toLowerCase(), e), !0;
        return !1;
    };
    d.prototype.getHash = function(a) {
        null == a && (a = location.hash);
        return String(a).replace(this.RegExpCache.extractHash, "$1");
    };
    d.prototype.resolveHash = function(a) {
        var b;
        if (this.observeHash) return this.eventSupported && (b = a.originalEvent.newURL), a = this.getHash(b), this.resolve(a, "get");
    };
    d.prototype.handleFormSubmit = function(a) {
        var b, c;
        this.observeForms && (b = jQuery(a.target), c = b.attr("method") || b.get(0).getAttribute("method"), b = this.getHash(b.attr("action")), this.resolve(b, c) && a.preventDefault());
        return !0;
    };
    d.prototype.listen = function() {
        var a = this;
        if (!this.listening) return jQuery(window).on("hashchange.simrou", this.resolveHash), jQuery(function() {
            return jQuery("body").on("submit.simrou", "form", a.handleFormSubmit);
        }), this.listening = !0;
    };
    d.prototype.start = function(a, b, c) {
        this.observeHash = null != b ? b : !0;
        this.observeForms = null != c ? c : !0;
        (this.observeHash || this.observeForms) && this.listen();
        b = this.getHash();
        if ("" !== b) return this.resolve(b, "get");
        if (null != a) return null != window.history && null != window.history.replaceState ? (window.history.replaceState({}, document.title, "#" + a.replace(/^#+/, "")), this.resolve(a, "get")) : this.navigate(a);
    };
    d.prototype.stop = function() {
        return this.observeForms = this.observeHash = !1;
    };
    g = function g(a, b) {
        var c, e;
        this.pattern = a;
        this.caseSensitive = null != b ? b : !0;
        a = String(this.pattern);
        e = a.match(this.RegExpCache.allParams);
        if (null != e) {
            var f, h, d;
            d = [];
            f = 0;
            for(h = e.length; f < h; f++)c = e[f], d.push(c.substr(1));
            this.params = d;
        } else this.params = [];
        a = a.replace(this.RegExpCache.escapeRegExp, "\\$&");
        a = a.replace(this.RegExpCache.namedParam, "([^/]+)");
        a = a.replace(this.RegExpCache.splatParam, "(.+?)");
        this.expr = RegExp("^" + a + "$", b ? "" : "i");
    };
    g.prototype.RegExpCache = {
        escapeRegExp: /[-[\]{}()+?.,\\^$|#\s]/g,
        namedParam: /:(\w+)/g,
        splatParam: /\*(\w+)/g,
        firstParam: /(:\w+)|(\*\w+)/,
        allParams: /(:|\*)\w+/g
    };
    g.prototype.match = function(a) {
        var b, c, e, f, d, g;
        b = this.expr.exec(a);
        if (jQuery.isArray(b)) {
            e = {};
            g = this.params;
            a = f = 0;
            for(d = g.length; f < d; a = ++f)c = g[a], e[c] = b[a + 1];
        } else e = !1;
        return e;
    };
    g.prototype.assemble = function() {
        var a, b, c;
        c = 1 <= arguments.length ? m.call(arguments, 0) : [];
        if (0 < c.length) {
            if (jQuery.isArray(c[0])) c = c[0];
            else if (jQuery.isPlainObject(c[0])) {
                var e, f, d;
                f = this.params;
                d = [];
                b = 0;
                for(e = f.length; b < e; b++)a = f[b], d.push(a in c[0] ? c[0][a] : "");
                c = d;
            }
        }
        for(a = String(this.pattern); this.RegExpCache.firstParam.test(a);)b = 0 < c.length ? c.shift() : "", jQuery.isFunction(b) && (b = b(this)), a = a.replace(this.RegExpCache.firstParam, String(b));
        return a;
    };
    g.prototype.toString = function() {
        return String(this.pattern);
    };
    g.prototype.attachAction = function(a, b) {
        null == b && (b = "any");
        jQuery(this).on("simrou:" + b.toLowerCase(), a);
        return this;
    };
    g.prototype.attachActions = function(a, b) {
        var c, e, d, g;
        null == b && (b = "any");
        jQuery.isPlainObject(a) || (c = [
            {},
            a
        ], a = c[0], c = c[1], a[b] = c);
        for(b in a)if (k.call(a, b)) {
            e = a[b];
            jQuery.isArray(e) || (e = [
                e
            ]);
            d = 0;
            for(g = e.length; d < g; d++)c = e[d], this.attachAction(c, b);
        }
        return this;
    };
    g.prototype.detachAction = function(a, b) {
        var c;
        null == b && (b = "any");
        "string" === typeof a && (b = a);
        c = "simrou:" + b.toLowerCase();
        jQuery.isFunction(a) ? jQuery(this).off(c, a) : jQuery(this).off(c);
        return this;
    };
    i = function i(a) {
        return function(b) {
            return this.attachAction(b, a);
        };
    };
    g.prototype.get = i("get");
    g.prototype.post = i("post");
    g.prototype.put = i("put");
    g.prototype["delete"] = i("delete");
    g.prototype.any = i("any");
    j = g;
    d.Route = j;
    window.Simrou = jQuery.Simrou = d;
}).call(this);

//# sourceMappingURL=web.ce5e537d.js.map
